import {
  deleteRequest,
  getRequest,
  putRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import {
  API_URLS,
  emptyString,
  PAGINATION_INDEXING,
  LIST_PAGE_SIZE,
} from "../constants";

const { MANAGER, PROFILE } = API_URLS;

//Function to get paginated Managers Against Brand ID
const getManagersByBrandId = (
  {
    search = emptyString,
    from = PAGINATION_INDEXING.FIRST_PAGE_INDEX,
    take = LIST_PAGE_SIZE,
  } = {},
  brandId
) => {
  return getRequest(
    `${MANAGER.GET_MANAGERS_BY_BRAND_ID}/${brandId}/?search=${encodeURIComponent(search)}&from=${from}&take=${take}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
//Function to get paginated Managers Against Group ID
const getManagersByGroupId = (
  {
    search = emptyString,
    from = PAGINATION_INDEXING.FIRST_PAGE_INDEX,
    take = LIST_PAGE_SIZE,
  } = {},
  brandId
) => {
  return getRequest(
    `${MANAGER.GET_MANAGERS_BY_GROUP_ID}/${brandId}/?search=${encodeURIComponent(search)}&from=${from}&take=${take}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to Delete Manager by ID
const deleteManager = (managerId) => {
  return deleteRequest(`${PROFILE.BASE}/${managerId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to remove brand location by BrandLocationID
const removeManagerLocation = (brandLocationId, managerId) => {
  return putRequest(
    `${MANAGER.REMOVE_LOCATION}/${brandLocationId}/${managerId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting Manager details by Manager Id
const getManagerDetails = (managerId) => {
  return getRequest(`${MANAGER.GET_MANAGERS_BY_ID}/${managerId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Function to update Managers
const updateManagerDetails = (body) => {
  return putRequest(MANAGER.UPDATE_MANAGER, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting all location
const getBrandlocations = (groupId) =>
  getRequest(`${MANAGER.GET_STORES}/${groupId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );

//Exporting functions for other files
export const managersService = {
  deleteManager,
  getBrandlocations,
  getManagerDetails,
  getManagersByBrandId,
  updateManagerDetails,
  removeManagerLocation,
  getManagersByGroupId,
};
